import { getNotificationContainer, showLoggerLogLevel } from '../notification-util';
/**
 * Shows the snackbar
 * @internal
 * @param notification - The NotificationStructure object
 * @param tagName - The tag name to create prefix for the design system provider & notification component
 * @returns
 * */
export const showSnackbar = (notificationStructure, tagName) => {
    showLoggerLogLevel(notificationStructure);
    const tagPrefix = tagName.split('-')[0];
    const snackbar = document.createElement(`${tagPrefix}-snackbar`);
    const container = getNotificationContainer('snack-container', tagName);
    container.appendChild(snackbar);
    snackbar.notification = notificationStructure;
};
